// Brand SVG icons for channels. Kept simple, single-file, monochrome-by-default with a `colored` prop.
import React from "react";

export function GmailIcon({ size = 20, colored = false }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-label="Gmail">
      {colored ? (
        <>
          <path d="M22 6.5v11a2.5 2.5 0 0 1-2.5 2.5H18V9.4l-6 4.5-6-4.5V20H4.5A2.5 2.5 0 0 1 2 17.5v-11A2.5 2.5 0 0 1 4.5 4H5l7 5.25L19 4h.5A2.5 2.5 0 0 1 22 6.5Z" fill="#EA4335" />
          <path d="M22 6.5 12 14 2 6.5A2.5 2.5 0 0 1 4.5 4h15A2.5 2.5 0 0 1 22 6.5Z" fill="#FBBC04" />
          <path d="M22 6.5v.1L12 14 2 6.6v-.1A2.5 2.5 0 0 1 4.5 4h15A2.5 2.5 0 0 1 22 6.5Z" fill="#4285F4" opacity=".2" />
        </>
      ) : (
        <path fill="currentColor" d="M22 6.5v11a2.5 2.5 0 0 1-2.5 2.5H18V9.4l-6 4.5-6-4.5V20H4.5A2.5 2.5 0 0 1 2 17.5v-11A2.5 2.5 0 0 1 4.5 4H5l7 5.25L19 4h.5A2.5 2.5 0 0 1 22 6.5Z" />
      )}
    </svg>
  );
}

export function SlackIcon({ size = 20, colored = false }) {
  if (!colored) {
    return (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-label="Slack">
        <path d="M6 15a2 2 0 1 1-2-2h2v2Zm1 0a2 2 0 1 1 4 0v5a2 2 0 1 1-4 0v-5Z" />
        <path d="M9 6a2 2 0 1 1 2-2v2H9Zm0 1a2 2 0 0 1 0 4H4a2 2 0 1 1 0-4h5Z" />
        <path d="M18 9a2 2 0 1 1 2 2h-2V9Zm-1 0a2 2 0 0 1-4 0V4a2 2 0 1 1 4 0v5Z" />
        <path d="M15 18a2 2 0 1 1-2 2v-2h2Zm0-1a2 2 0 0 1 0-4h5a2 2 0 1 1 0 4h-5Z" />
      </svg>
    );
  }
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-label="Slack">
      <path fill="#36C5F0" d="M9 6a2 2 0 1 1 2-2v2H9Zm0 1a2 2 0 0 1 0 4H4a2 2 0 1 1 0-4h5Z" />
      <path fill="#2EB67D" d="M18 9a2 2 0 1 1 2 2h-2V9Zm-1 0a2 2 0 0 1-4 0V4a2 2 0 1 1 4 0v5Z" />
      <path fill="#ECB22E" d="M15 18a2 2 0 1 1-2 2v-2h2Zm0-1a2 2 0 0 1 0-4h5a2 2 0 1 1 0 4h-5Z" />
      <path fill="#E01E5A" d="M6 15a2 2 0 1 1-2-2h2v2Zm1 0a2 2 0 1 1 4 0v5a2 2 0 1 1-4 0v-5Z" />
    </svg>
  );
}

export function NotionIcon({ size = 20, colored = false }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-label="Notion">
      <rect x="3" y="3" width="18" height="18" rx="2" fill={colored ? "#FFFFFF" : "none"} stroke={colored ? "#000" : "currentColor"} strokeWidth="1.4" />
      <path d="M8 7.5v9M8 7.5l8 9M16 7.5v9" stroke={colored ? "#000" : "currentColor"} strokeWidth="1.4" fill="none" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function LinkedInIcon({ size = 20, colored = false }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-label="LinkedIn">
      <rect width="24" height="24" rx="3" fill={colored ? "#0A66C2" : "none"} />
      <path fill={colored ? "#fff" : "currentColor"} d="M7.1 9.5H4.7V20h2.4V9.5Zm-1.2-4a1.4 1.4 0 1 0 0 2.8 1.4 1.4 0 0 0 0-2.8ZM20 20h-2.4v-5.4c0-1.3-.5-2.2-1.7-2.2-1 0-1.6.7-1.8 1.3-.1.2-.1.5-.1.8V20H11.7v-7.1c0-.9 0-1.8-.1-2.4h2.1l.1 1.4h.1c.4-.7 1.3-1.6 3-1.6 2.2 0 3.9 1.4 3.9 4.5V20Z" />
    </svg>
  );
}

export function WhatsAppIcon({ size = 20, colored = false }) {
  if (!colored) {
    return (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-label="WhatsApp">
        <path d="M12 2a10 10 0 0 0-8.5 15.2L2 22l4.9-1.4A10 10 0 1 0 12 2Zm5.4 14.3c-.2.6-1.2 1.2-1.7 1.3-.5.1-1 .1-1.6-.1-.4-.1-.9-.3-1.5-.5-2.7-1.1-4.4-3.8-4.5-4-.1-.2-1.1-1.4-1.1-2.7 0-1.3.7-1.9.9-2.2.2-.3.5-.3.7-.3h.5c.2 0 .5-.1.7.5.3.7.9 2.2 1 2.4.1.1.1.3 0 .5-.1.2-.2.3-.3.5l-.4.4c-.1.1-.3.3-.1.6.2.3.9 1.5 2 2.4 1.4 1.2 2.5 1.6 2.8 1.8.3.2.5.1.7-.1s.8-.9 1-1.3c.2-.3.4-.3.7-.2s1.8.9 2.1 1c.3.2.5.3.6.4.1.2.1.9-.1 1.6Z" />
      </svg>
    );
  }
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-label="WhatsApp">
      <path fill="#25D366" d="M12 2a10 10 0 0 0-8.5 15.2L2 22l4.9-1.4A10 10 0 1 0 12 2Z" />
      <path fill="#fff" d="M17.4 16.3c-.2.6-1.2 1.2-1.7 1.3-.5.1-1 .1-1.6-.1-.4-.1-.9-.3-1.5-.5-2.7-1.1-4.4-3.8-4.5-4-.1-.2-1.1-1.4-1.1-2.7 0-1.3.7-1.9.9-2.2.2-.3.5-.3.7-.3h.5c.2 0 .5-.1.7.5.3.7.9 2.2 1 2.4.1.1.1.3 0 .5-.1.2-.2.3-.3.5l-.4.4c-.1.1-.3.3-.1.6.2.3.9 1.5 2 2.4 1.4 1.2 2.5 1.6 2.8 1.8.3.2.5.1.7-.1s.8-.9 1-1.3c.2-.3.4-.3.7-.2s1.8.9 2.1 1c.3.2.5.3.6.4.1.2.1.9-.1 1.6Z" />
    </svg>
  );
}

// Generic channel icon by key — used across the app for source badges
import { Mail, MessageSquare, PenLine, Calendar, Video, Users, MessageCircle } from "lucide-react";
export function ChannelIcon({ channel, size = 14, className = "" }) {
  const map = {
    gmail: <GmailIcon size={size} />,
    email: <Mail size={size} />,
    slack: <SlackIcon size={size} />,
    teams: <Users size={size} />,
    whatsapp: <WhatsAppIcon size={size} />,
    zoom: <Video size={size} />,
    calendar: <Calendar size={size} />,
    notion: <NotionIcon size={size} />,
    linkedin: <LinkedInIcon size={size} />,
    manual: <PenLine size={size} />,
  };
  return <span className={`inline-flex text-neutral-400 ${className}`}>{map[channel] || <MessageCircle size={size} />}</span>;
}
